import clsx from "clsx";
import type { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import { showNotification } from "../../helpers/showNotification";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { RowContainer } from "../../pages/login/styles";
import { verifyOtpCodeAction } from "../../store/actions/authActions";
import { authSlice } from "../../store/reducers/AuthSlice";
import { CButton, CInput } from "../common";
import { ErrorMessage } from "../ErrorMessage";
import { RepeatedSending } from "../registration/RepeatedSending";

interface Props {
    handleChangeStep: () => void;
}

export const SecondStep: FC<Props> = ({ handleChangeStep }) => {
    const { reset, error, isLoading } = useAppSelector((state) => state.authReducer);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const onChangeCodeField = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(authSlice.actions.updateResetPasswordForm({ ...reset, code: e.target.value }));
    };

    const onSubmitData = async () => {
        try {
            await dispatch(verifyOtpCodeAction(reset.email, reset.code));
            handleChangeStep();
        } catch (error) {
            showNotification(t("Server error"), "error");
        }
    };

    return (
        <RowContainer>
            <div className="code__field">
                <CInput
                    label={t("Code")}
                    name="code"
                    type="number"
                    value={reset.code}
                    placeholder={t("Enter the 6-digit code")}
                    onChange={onChangeCodeField}
                />
                <p className={clsx(error ? "error" : "description")}>
                    {error
                        ? t("The entered code is not valid")
                        : t("Enter the 6-digit code that was sent by SMS to your number")}
                    <RepeatedSending login={reset.email} />
                </p>
            </div>
            <CButton
                onClick={onSubmitData}
                loading={isLoading}
                disabled={!reset.code || reset.code.length < 6}
            >
                {t("Continue password recovery")}
            </CButton>
            {error && <ErrorMessage message={error} />}
        </RowContainer>
    );
};
